import { useContext, type ReactNode } from "react";
import { Leaf } from "lucide-react";
import { formatBRL } from "@clareza/domain";
import { Privacy } from "../contexts/privacy.ts";
export function Money({
  value,
  className = "",
}: {
  value: string | null;
  className?: string;
}) {
  const hidden = useContext(Privacy);
  return (
    <span className={`money ${className}`}>
      {hidden ? "••••••" : formatBRL(value)}
    </span>
  );
}

export function DateLabel({ date }: { date: string | null }) {
  if (!date) return <>Data não informada</>;
  return (
    <>
      {new Intl.DateTimeFormat("pt-BR", {
        day: "2-digit",
        month: "short",
        timeZone: "UTC",
      })
        .format(new Date(`${date}T12:00:00Z`))
        .replace(".", "")}
    </>
  );
}

export function Panel({
  children,
  title,
  subtitle,
  action,
  className = "",
}: {
  children: ReactNode;
  title?: string;
  subtitle?: string;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <section className={`panel ${className}`}>
      {title && (
        <div className="panel-heading">
          <div>
            <h2>{title}</h2>
            {subtitle && <p>{subtitle}</p>}
          </div>
          {action}
        </div>
      )}
      {children}
    </section>
  );
}

export function Empty({
  title,
  description,
  action,
}: {
  title: string;
  description: string;
  action?: ReactNode;
}) {
  return (
    <div className="empty">
      <span className="empty-icon">
        <Leaf size={25} />
      </span>
      <h3>{title}</h3>
      <p>{description}</p>
      {action}
    </div>
  );
}
